export default "__VITE_ASSET__tyEZMK6f__"